// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__iliVb","spinner":"button_spinner__J9_jS","iconButton":"button_iconButton___j2Bg"};